// extracted by mini-css-extract-plugin
export var animationContainer = "_oz-0";
export var footer = "_oz-1";
export var gray = "_oz-2";
export var lineItem = "_oz-3";
export var lineItemImage = "_oz-4";
export var lineItemInfo = "_oz-5";
export var lineItemText = "_oz-6";
export var lineItems = "_oz-7";
export var modalContent = "_oz-8";
export var options = "_oz-9";
export var orderName = "_oz-a";
export var refundAmount = "_oz-b";